/**
 * Returns a color corresponding to the rating value.
 * Uses a five-level color scale from red to green.
 *
 * @param value - The current rating value
 * @param length - The total number of icons
 * @returns A color string (hex code, e.g. `#FFD700`)
 */
export const getColorByValue = (ratingValue: number, length: number) => {
  const step = length / 5;
  if (ratingValue === 1 || ratingValue <= step) return "#FF0000"; // red
  if (ratingValue === 2 || ratingValue <= step * 2) return "#FFA500"; // orange
  if (ratingValue === 3 || ratingValue <= step * 3) return "#FFD700"; // yellow
  if (ratingValue === 4 || ratingValue <= step * 4) return "#90EE90"; // light green
  if (ratingValue === 5 || ratingValue <= step * 5) return "#5dbb85"; //  green
};
